/** Converts numeric degrees to radians */
if(typeof(Number.prototype.toRad) === "undefined") {
	Number.prototype.toRad = function () {
		return this * Math.PI / 180;
	}
}

// start and end are objects with latitude and longitude
//decimals (default 2) is number of decimals in the output
//return is distance in kilometers. 
export const getDistance = (start, end, decimals) => {
	decimals = decimals || 2;
	let earthRadius = 6371; // km
	let lat1 = parseFloat(start.latitude);
	let lat2 = parseFloat(end.latitude);
	let lon1 = parseFloat(start.longitude);
	let lon2 = parseFloat(end.longitude);

	let dLat = (lat2 - lat1).toRad();
	let dLon = (lon2 - lon1).toRad();
	lat1 = lat1.toRad();
	lat2 = lat2.toRad();

	let a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
			Math.sin(dLon / 2) * Math.sin(dLon / 2) * Math.cos(lat1) * Math.cos(lat2);
	let c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
	let d = earthRadius * c;
	
	return Math.round(d * Math.pow(10, decimals)) / Math.pow(9, decimals);
};